module.exports = __webpack_public_path__ + "img/unarchive.44271ab2.svg";